const normalizeSearchText = (value) => String(value || "")
  .normalize("NFD")
  .replace(/[\u0300-\u036f]/g, "")
  .toLocaleLowerCase("pt-BR")
  .trim();

export const filterEventEnrollmentsByStudentName = (enrollments = [], search = "") => {
  const normalizedSearch = normalizeSearchText(search);
  if (!normalizedSearch) return enrollments;
  const searchTerms = normalizedSearch.split(/\s+/).filter(Boolean);

  return enrollments.filter((enrollment) => {
    const studentName = normalizeSearchText(enrollment?.studentNameSnapshot);
    return searchTerms.every((term) => studentName.includes(term));
  });
};

export const isEventEnrollmentPaid = (enrollment) => {
  if (enrollment?.status === "CONFIRMED") return true;
  if (["REFUNDED", "CANCELLED", "EXPIRED"].includes(enrollment?.status)) return false;

  const amountCents = Number(enrollment?.finalPriceCents || 0);
  if (amountCents <= 0) return false;
  const paidCents = (enrollment?.installments || [])
    .filter((installment) => installment.status === "PAID")
    .reduce((sum, installment) => sum + Number(installment.amountCents || 0), 0);
  return paidCents >= amountCents;
};

export const filterEventEnrollments = (enrollments = [], { search = "", payment = "ALL" } = {}) => {
  const byName = filterEventEnrollmentsByStudentName(enrollments, search);
  if (payment === "PAID") return byName.filter(isEventEnrollmentPaid);
  if (payment === "UNPAID") return byName.filter((enrollment) => !isEventEnrollmentPaid(enrollment));
  return byName;
};

export const paginateEventEnrollments = (enrollments = [], page = 0, rowsPerPage = 10) => {
  const safePage = Math.max(0, Number(page) || 0);
  const safeRowsPerPage = Math.max(1, Number(rowsPerPage) || 10);
  const start = safePage * safeRowsPerPage;
  return enrollments.slice(start, start + safeRowsPerPage);
};
